import { Directive } from '@angular/core';

@Directive({
  selector: '[myAccountLink]',
  standalone: false,
})
export class MyAccountLinkDirective {
  constructor() {}
}
